<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-organization-inn" class="control-label">{{ getInputLabel }}</label>
    <input-facade
        class="form-control text-uppercase"
        v-model="inputValue"
        masked
        id="form-organization-inn"
        :mask="getDocumentMask"
        :disabled="disabled"
        :tokens="inputFacadeTokens"
        :placeholder="getDocumentHint"
        @change="emitValue('change', $event)"
        @input="emitValue('input', $event)"
        @blur="emitValue('blur', $event)"
        @keydown="emit"
        @keyup="emit"
    />
    <template v-if="!isFizOrganizationSubject">
      <typeahead
        :async-function="typeahead"
        :item-key="typeaheadItemKey"
        :limit="typeaheadLimit"
        target="#form-organization-inn"
        v-model="form.organization.innData"
        @input="selectTypeahead($event, true)"
      >
        <template v-slot:item="props">
          <li
            v-for="(item, index) in props.items"
            v-bind:key="item.id"
            :class="{ active: props.activeIndex === index }"
          >
            <a role="button" @click="props.select(item)">
              <div v-html="props.highlight(item)"></div>
              <div v-if="item && item.inn">{{ item.inn}}</div>
              <div v-if="item && item.org_name">{{ item.org_name }}</div>
              <div v-if="item && item.address">{{ item.address}}</div>
            </a>
          </li>
        </template>
      </typeahead>
    </template>
    <div v-if="form.organization.innControlSumErr" class="form-fielderror trailer-error">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Контрольные суммы не совпадают. Введите правильный ИНН.</div>
      </div>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import organizationSectionMixin from '@/common/mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '@/common/mixins/application-form/organizationInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'OrganizationInnInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'ИНН'
    },

    inputName: {
      default: 'inn'
    },

    inputHint: {
      default: undefined
    },

    organizationSubjectsResidency: {
      default: []
    }
  },

  computed: {
    inputFacadeTokens() {
      return {
        '#': { pattern: /\d/ },
        S: { pattern: /[a-zA-Z]/ },
        R: { pattern: /[А-Яа-я]/ },
        N: { pattern: /[I|V|X|C|D|M|L]/i },
        M: { pattern: /[0-9А-Яа-яa-zA-Z]/ }
      }
    },

    getInputLabel() {
      return this.getOrgSubResidency?.inn_name ?? this.inputLabel
    },

    getOrgSubResidency() {
      return this.organizationSubjectsResidency.find(
        nationality => Number(nationality.nationality_id) === this.form.organization.nationality_id &&
          nationality.subject_id === this.form.organization.subject_id
      )
    },

    getDocumentHint() {
      return this.getOrgSubResidency?.hint ?? ''
    },

    getDocumentMask() {
      return this.getOrgSubResidency?.mask ? JSON.parse(this.getOrgSubResidency?.mask) : 'XXXXXXXXXXXXXXXX'
    }
  }
}
</script>
